import { css } from '@emotion/css';

export default function group6() {
  return (
    <div>
      <div
        className={css`
          max-width: 1186px;
          margin: 0 auto;
        `}
      >
        <div className='flex'>
          <div
            className={css`
              width: 40%;
              margin: 0 auto;
              margin-top: 17px;
              height: 2px;
              border: 1px solid #745a82;
            `}
          ></div>
          <h1
            className={css`
              width: max-content;

              color: #745a82;
              font-family: 'Open Sans - Semibold';
              font-size: 33px;
              font-weight: 400;
              font-style: normal;
              letter-spacing: normal;
              line-height: 45.83px;
              text-align: center;
              text-transform: uppercase;
              font-family: 'Open Sans - Semibold';
              font-weight: 600;
              font-style: normal;
              letter-spacing: normal;
              line-height: normal;
              font-family: 'Open Sans';
              font-weight: 300;
              font-style: normal;
              letter-spacing: normal;
              line-height: normal;
              margin-bottom: 115px;
            `}
          >
            HEALTHY <br /> LIFE
          </h1>
          <div
            className={css`
              /* Style for "Background" */
              /* Style for "Line" */
              width: 40%;
              margin: 0 auto;
              margin-top: 17px;
              height: 2px;
              border: 1px solid #745a82;
            `}
          ></div>
        </div>

        <div className='grid grid-cols-3 sm:grid-cols-1 w-11/12 mx-auto gap-20'>
          <div>
            <img
              className={
                'rounded-full	 ' +
                css`
                  width: 137px;
                  display: block;
                  margin: 0 auto;

                  height: 137px;
                  margin-bottom: 45px;
                `
              }
              src='img/Place_Your_Design_Here_(Double_Click_to_Edit).png'
              alt=''
            />
            <h1
              className={css`
                text-align: center;
                color: #745a82;
                font-family: 'Open Sans';
                font-size: 25px;
                font-weight: 700;
                font-style: normal;
                letter-spacing: normal;
                line-height: 45.83px;
                text-transform: uppercase;
                font-style: normal;
                letter-spacing: normal;
                line-height: normal;
                margin-bottom: 50px;
              `}
            >
              EXERCISE
            </h1>
            <p
              className={css`
                color: #745a82;
                font-family: 'Open Sans';
                font-size: 25px;
                font-weight: 300;
                font-style: normal;
                letter-spacing: normal;
                line-height: 37.5px;
                text-align: center;
                font-style: normal;
                letter-spacing: normal;
                line-height: normal;
              `}
            >
              Lorem ipsum dolor sit amet consectetur adipiscing, elit molestie
              posuere
            </p>
          </div>

          <div>
            <img
              className={
                'rounded-full	 ' +
                css`
                  width: 137px;
                  display: block;
                  margin: 0 auto;
                  height: 137px;
                  margin-bottom: 45px;
                `
              }
              src='img/Place_Your_Design_Here_(Double_Click_to_Edit).png'
              alt=''
            />
            <h1
              className={css`
                text-align: center;
                color: #745a82;
                font-family: 'Open Sans';
                font-size: 25px;
                font-weight: 700;
                font-style: normal;
                letter-spacing: normal;
                line-height: 45.83px;
                text-transform: uppercase;
                font-style: normal;
                letter-spacing: normal;
                line-height: normal;
                margin-bottom: 50px;
              `}
            >
              EXERCISE
            </h1>
            <p
              className={css`
                color: #745a82;
                font-family: 'Open Sans';
                font-size: 25px;
                font-weight: 300;
                font-style: normal;
                letter-spacing: normal;
                line-height: 37.5px;
                text-align: center;

                font-style: normal;
                letter-spacing: normal;
                line-height: normal;
              `}
            >
              Lorem ipsum dolor sit amet consectetur adipiscing, elit molestie
              posuere
            </p>
          </div>
          <div>
            <img
              className={
                'rounded-full	 ' +
                css`
                  width: 137px;
                  display: block;
                  margin: 0 auto;
                  height: 137px;
                  margin-bottom: 45px;
                `
              }
              src='img/Place_Your_Design_Here_(Double_Click_to_Edit).png'
              alt=''
            />
            <h1
              className={css`
                text-align: center;
                color: #745a82;
                font-family: 'Open Sans';
                font-size: 25px;
                font-weight: 700;
                font-style: normal;
                letter-spacing: normal;
                line-height: 45.83px;

                text-transform: uppercase;

                font-style: normal;
                letter-spacing: normal;
                line-height: normal;
                margin-bottom: 50px;
              `}
            >
              EXERCISE
            </h1>
            <p
              className={css`
                color: #745a82;
                font-family: 'Open Sans';
                font-size: 25px;
                font-weight: 300;
                font-style: normal;
                letter-spacing: normal;
                line-height: 37.5px;
                text-align: center;

                font-style: normal;
                letter-spacing: normal;
                line-height: normal;
              `}
            >
              Lorem ipsum dolor sit amet consectetur adipiscing, elit molestie
              posuere
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
